import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../../context/AuthContext'
import { EvalApiService } from '../../services/EvalApiService'
import { DatasetStatus, EvalGtDataset } from '../../types'
import { fmtIso } from '../../utils'
import { TagList } from '../../components/common/TagList'


const STATUS_STYLES: Record<DatasetStatus, React.CSSProperties> = {
  locked: { color: 'var(--positive)', fontSize: 11, fontWeight: 600 },
  draft: { color: 'var(--warning)', fontSize: 11, fontWeight: 600 },
}

export const DatasetListPage: React.FC = () => {
  const { token } = useAuthContext()
  const navigate = useNavigate()
  const [datasets, setDatasets] = useState<EvalGtDataset[]>([])
  const [loading, setLoading] = useState(true)
  const [statusFilter, setStatusFilter] = useState<string>('')

  useEffect(() => {
    setLoading(true)
    EvalApiService.listDatasets(token ?? '').then(({ items }) => {
      setDatasets(items)
      setLoading(false)
    })
  }, [token])

  const filtered = datasets.filter((d) => !statusFilter || d.status === statusFilter)

  return (
    <div className="page-content">
      <div className="eval-page-header">
        <div>
          <div className="eval-page-title">GT Datasets</div>
          <div className="eval-page-sub">{datasets.length} datasets</div>
        </div>
        <button className="eval-btn" onClick={() => navigate('/eval/datasets/new')}>
          New Dataset
        </button>
      </div>

      <div className="eval-filters">
        <select
          className="eval-filter-select"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="">All statuses</option>
          <option value="locked">Locked</option>
          <option value="draft">Draft</option>
        </select>
      </div>

      {loading ? (
        <div style={{ color: 'var(--text-secondary)', fontSize: 13 }}>Loading...</div>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>Samples</th>
              <th>Tags</th>
              <th>Created By</th>
              <th>Created At</th>
              <th>Locked At</th>
              <th>Modified At</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((d) => (
              <tr key={d.dataset_id}>
                <td>
                  <Link
                    to={`/eval/datasets/${d.dataset_id}`}
                    style={{ color: 'var(--accent)', fontWeight: 500 }}
                  >
                    {d.dataset_name}
                  </Link>
                </td>
                <td>
                  <span style={STATUS_STYLES[d.status]}>
                    {d.status.charAt(0).toUpperCase() + d.status.slice(1)}
                  </span>
                </td>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>{d.sample_count}</td>
                <td><TagList tags={d.tags} /></td>
                <td style={{ fontSize: 12 }}>{d.created_by ?? '—'}</td>
                <td style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{fmtIso(d.created_at)}</td>
                <td style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
                  {fmtIso(d.locked_at)}
                </td>
                <td style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
                  {fmtIso(d.last_sample_updated_at)}
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={8} style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: 24 }}>
                  No datasets found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  )
}
